export  const APP_NAME = "MSD - Warehouse Environment Monitoring Tool"

export const INPUT_FIELD_TYPES = [
  'text',
  'email',
  'password',
  'number',
  'tel',
  'range',
  'textarea',
  'select',
  'radio',
  'checkbox',
  'file',
  'url',
  'toggle',
];


export const ALPHABETS = `A B C D E F G H I J K L M N O P Q R S T U V W X Y Z`.split(' ');

export const FIRST_20_NUMBERS_IN_WORDS = `zero one two three four five six seven eight nine ten
eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen`.split(' ');

export const TENTHS = 'twenty thirty forty fifty sixty seventy eighty ninety'.split(' ');

export const UNCOUNTABLE_WORDS: string[] = [
  'sheep',
  'fish',
  'deer',
  'moose',
  'series',
  'species',
  'money',
  'rice',
  'information',
  'equipment',
  'bison',
  'cod',
  'offspring',
  'pike',
  'salmon',
  'shrimp',
  'swine',
  'trout',
  'aircraft',
  'hovercraft',
  'spacecraft',
  'sugar',
  'tuna',
  'you',
  'wood',
];

export const IRREGULAR_SINGULAR_PLURAL_PAIRS: { [key: string]: string } = {
  move: 'moves',
  foot: 'feet',
  goose: 'geese',
  sex: 'sexes',
  child: 'children',
  man: 'men',
  tooth: 'teeth',
  person: 'people',
};

export const PLURAL_TO_SINGULAR_PAIRS: { [key: string]: string } = {
  '(quiz)zes$': '$1',
  '(matr)ices$': '$1ix',
  '(vert|ind)ices$': '$1ex',
  '^(ox)en$': '$1',
  '(alias)es$': '$1',
  '(octop|vir)i$': '$1us',
  '(cris|ax|test)es$': '$1is',
  '(shoe)s$': '$1',
  '(o)es$': '$1',
  '(bus)es$': '$1',
  '([m|l])ice$': '$1ouse',
  '(x|ch|ss|sh)es$': '$1',
  '(m)ovies$': '$1ovie',
  '(s)eries$': '$1eries',
  '([^aeiouy]|qu)ies$': '$1y',
  '([lr])ves$': '$1f',
  '(tive)s$': '$1',
  '(hive)s$': '$1',
  '(li|wi|kni)ves$': '$1fe',
  '(shea|loa|lea|thie)ves$': '$1f',
  '(^analy)ses$': '$1sis',
  '((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$': '$1$2sis',
  '([ti])a$': '$1um',
  '(n)ews$': '$1ews',
  '(h|bl)ouses$': '$1ouse',
  '(corpse)s$': '$1',
  '(us)es$': '$1',
  's$': '',
};

export const SINGULAR_TO_PLURAL_PAIRS: { [key: string]: string } = {
  '(quiz)$': '$1zes',
  '^(ox)$': '$1en',
  '([m|l])ouse$': '$1ice',
  '(matr|vert|ind)ix|ex$': '$1ices',
  '(x|ch|ss|sh)$': '$1es',
  '([^aeiouy]|qu)y$': '$1ies',
  '(hive)$': '$1s',
  '(?:([^f])fe|([lr])f)$': '$1$2ves',
  '(shea|lea|loa|thie)f$': '$1ves',
  'sis$': 'ses',
  '([ti])um$': '$1a',
  '(tomat|potat|ech|her|vet)o$': '$1oes',
  '(bu)s$': '$1ses',
  '(alias)$': '$1es',
  '(octop)us$': '$1i',
  '(ax|test)is$': '$1es',
  '(us)$': '$1es',
  '([^s]+)$': '$1s',
};

export const PLURAL_TO_SINGULAR_ENDINGS_PAIRS = {
  ves: 'fe',
  ies: 'y',
  i: 'us',
  zes: '',
  ses: '',
  es: '',
  s: '',
};


export const INPUT_CONTAINER_CLASS = `
  thin-form-fields 
  mat-form-field-no-margin 
  rounded-medium 
  mat-form-field-no-padding 
  d-inline-flex 
  align-items-center 
  border-slightly-faded 
  bg-gradient-very-faded 
  padding-1 
  m-1 
  mb-0 
  mr-3 
  flex-wrap 
  dark:border-gray-700 
  dark:bg-gray-800 
  dark:text-gray-300
`;
export const DATA_FIELD_CLASS = `
  custom-fill 
  hide-arrow 
  bg-none 
  material-form 
  my-0 
  dark:bg-gray-800 
  dark:text-gray-300 
  dark:border-gray-700
`;
export const LIST_STATE_VALUE_CLASS = `d-inline-block text-center p-1 m-1 px-2 rounded-small
border-slightly-faded_  bg-hover-slightly-gradient cursor-pointer text-bold border-on-hover`;


export const countries: { key: string, value: string }[] = [
  {"key": "Afghanistan", "value": "Afghanistan"},
  {"key": "Albania", "value": "Albania"},
  {"key": "Algeria", "value": "Algeria"},
  {"key": "American Samoa", "value": "American Samoa"},
  {"key": "Andorra", "value": "Andorra"},
  {"key": "Angola", "value": "Angola"},
  {"key": "Anguilla", "value": "Anguilla"},
  {"key": "Antigua and Barbuda", "value": "Antigua and Barbuda"},
  {"key": "Argentina", "value": "Argentina"},
  {"key": "Armenia", "value": "Armenia"},
  {"key": "Aruba", "value": "Aruba"},
  {"key": "Australia", "value": "Australia"},
  {"key": "Austria", "value": "Austria"},
  {"key": "Azerbaijan", "value": "Azerbaijan"},
  {"key": "Bahamas", "value": "Bahamas"},
  {"key": "Bahrain", "value": "Bahrain"},
  {"key": "Bangladesh", "value": "Bangladesh"},
  {"key": "Barbados", "value": "Barbados"},
  {"key": "Belarus", "value": "Belarus"},
  {"key": "Belgium", "value": "Belgium"},
  {"key": "Belize", "value": "Belize"},
  {"key": "Benin", "value": "Benin"},
  {"key": "Bermuda", "value": "Bermuda"},
  {"key": "Bhutan", "value": "Bhutan"},
  {"key": "Bolivia", "value": "Bolivia"},
  {"key": "Bosnia and Herzegovina", "value": "Bosnia and Herzegovina"},
  {"key": "Botswana", "value": "Botswana"},
  {"key": "Brazil", "value": "Brazil"},
  {"key": "British Virgin Islands", "value": "British Virgin Islands"},
  {"key": "Brunei", "value": "Brunei"},
  {"key": "Bulgaria", "value": "Bulgaria"},
  {"key": "Burkina Faso", "value": "Burkina Faso"},
  {"key": "Burundi", "value": "Burundi"},
  {"key": "Cambodia", "value": "Cambodia"},
  {"key": "Cameroon", "value": "Cameroon"},
  {"key": "Canada", "value": "Canada"},
  {"key": "Cape Verde", "value": "Cape Verde"},
  {"key": "Cayman Islands", "value": "Cayman Islands"},
  {"key": "Central African Republic", "value": "Central African Republic"},
  {"key": "Chad", "value": "Chad"},
  {"key": "Chile", "value": "Chile"},
  {"key": "China", "value": "China"},
  {"key": "Colombia", "value": "Colombia"},
  {"key": "Comoros", "value": "Comoros"},
  {"key": "Cook Islands", "value": "Cook Islands"},
  {"key": "Costa Rica", "value": "Costa Rica"},
  {"key": "Croatia", "value": "Croatia"},
  {"key": "Cuba", "value": "Cuba"},
  {"key": "Curacao", "value": "Curacao"},
  {"key": "Cyprus", "value": "Cyprus"},
  {"key": "Czech Republic", "value": "Czech Republic"},
  {"key": "Denmark", "value": "Denmark"},
  {"key": "Djibouti", "value": "Djibouti"},
  {"key": "Dominica", "value": "Dominica"},
  {"key": "Dominican Republic", "value": "Dominican Republic"},
  {"key": "DR Congo", "value": "DR Congo"},
  {"key": "Ecuador", "value": "Ecuador"},
  {"key": "Egypt", "value": "Egypt"},
  {"key": "El Salvador", "value": "El Salvador"},
  {"key": "Equatorial Guinea", "value": "Equatorial Guinea"},
  {"key": "Eritrea", "value": "Eritrea"},
  {"key": "Estonia", "value": "Estonia"},
  {"key": "Eswatini", "value": "Eswatini"},
  {"key": "Ethiopia", "value": "Ethiopia"},
  {"key": "Falkland Islands", "value": "Falkland Islands"},
  {"key": "Faroe Islands", "value": "Faroe Islands"},
  {"key": "Fiji", "value": "Fiji"},
  {"key": "Finland", "value": "Finland"},
  {"key": "France", "value": "France"},
  {"key": "French Guiana", "value": "French Guiana"},
  {"key": "French Polynesia", "value": "French Polynesia"},
  {"key": "Gabon", "value": "Gabon"},
  {"key": "Gambia", "value": "Gambia"},
  {"key": "Georgia", "value": "Georgia"},
  {"key": "Germany", "value": "Germany"},
  {"key": "Ghana", "value": "Ghana"},
  {"key": "Gibraltar", "value": "Gibraltar"},
  {"key": "Greece", "value": "Greece"},
  {"key": "Greenland", "value": "Greenland"},
  {"key": "Grenada", "value": "Grenada"},
  {"key": "Guadeloupe", "value": "Guadeloupe"},
  {"key": "Guam", "value": "Guam"},
  {"key": "Guatemala", "value": "Guatemala"},
  {"key": "Guinea", "value": "Guinea"},
  {"key": "Guinea-Bissau", "value": "Guinea-Bissau"},
  {"key": "Guyana", "value": "Guyana"},
  {"key": "Haiti", "value": "Haiti"},
  {"key": "Honduras", "value": "Honduras"},
  {"key": "Hong Kong", "value": "Hong Kong"},
  {"key": "Hungary", "value": "Hungary"},
  {"key": "Iceland", "value": "Iceland"},
  {"key": "India", "value": "India"},
  {"key": "Indonesia", "value": "Indonesia"},
  {"key": "Iran", "value": "Iran"},
  {"key": "Iraq", "value": "Iraq"},
  {"key": "Ireland", "value": "Ireland"},
  {"key": "Isle of Man", "value": "Isle of Man"},
  {"key": "Israel", "value": "Israel"},
  {"key": "Italy", "value": "Italy"},
  {"key": "Ivory Coast", "value": "Ivory Coast"},
  {"key": "Jamaica", "value": "Jamaica"},
  {"key": "Japan", "value": "Japan"},
  {"key": "Jordan", "value": "Jordan"},
  {"key": "Kazakhstan", "value": "Kazakhstan"},
  {"key": "Kenya", "value": "Kenya"},
  {"key": "Kiribati", "value": "Kiribati"},
  {"key": "Kuwait", "value": "Kuwait"},
  {"key": "Kyrgyzstan", "value": "Kyrgyzstan"},
  {"key": "Laos", "value": "Laos"},
  {"key": "Latvia", "value": "Latvia"},
  {"key": "Lebanon", "value": "Lebanon"},
  {"key": "Lesotho", "value": "Lesotho"},
  {"key": "Liberia", "value": "Liberia"},
  {"key": "Libya", "value": "Libya"},
  {"key": "Liechtenstein", "value": "Liechtenstein"},
  {"key": "Lithuania", "value": "Lithuania"},
  {"key": "Luxembourg", "value": "Luxembourg"},
  {"key": "Macau", "value": "Macau"},
  {"key": "Madagascar", "value": "Madagascar"},
  {"key": "Malawi", "value": "Malawi"},
  {"key": "Malaysia", "value": "Malaysia"},
  {"key": "Maldives", "value": "Maldives"},
  {"key": "Mali", "value": "Mali"},
  {"key": "Malta", "value": "Malta"},
  {"key": "Marshall Islands", "value": "Marshall Islands"},
  {"key": "Martinique", "value": "Martinique"},
  {"key": "Mauritania", "value": "Mauritania"},
  {"key": "Mauritius", "value": "Mauritius"},
  {"key": "Mayotte", "value": "Mayotte"},
  {"key": "Mexico", "value": "Mexico"},
  {"key": "Micronesia", "value": "Micronesia"},


  {"key": "Moldova", "value": "Moldova"},
  {"key": "Monaco", "value": "Monaco"},
  {"key": "Mongolia", "value": "Mongolia"},
  {"key": "Montenegro", "value": "Montenegro"},
  {"key": "Montserrat", "value": "Montserrat"},
  {"key": "Morocco", "value": "Morocco"},
  {"key": "Mozambique", "value": "Mozambique"},
  {"key": "Myanmar", "value": "Myanmar"},
  {"key": "Namibia", "value": "Namibia"},
  {"key": "Nauru", "value": "Nauru"},
  {"key": "Nepal", "value": "Nepal"},
  {"key": "Netherlands", "value": "Netherlands"},
  {"key": "New Caledonia", "value": "New Caledonia"},
  {"key": "New Zealand", "value": "New Zealand"},
  {"key": "Nicaragua", "value": "Nicaragua"},
  {"key": "Niger", "value": "Niger"},
  {"key": "Nigeria", "value": "Nigeria"},
  {"key": "Niue", "value": "Niue"},
  {"key": "North Korea", "value": "North Korea"},
  {"key": "North Macedonia", "value": "North Macedonia"},
  {"key": "Northern Mariana Islands", "value": "Northern Mariana Islands"},
  {"key": "Norway", "value": "Norway"},
  {"key": "Oman", "value": "Oman"},
  {"key": "Pakistan", "value": "Pakistan"},
  {"key": "Palau", "value": "Palau"},
  {"key": "Palestine", "value": "Palestine"},
  {"key": "Panama", "value": "Panama"},
  {"key": "Papua New Guinea", "value": "Papua New Guinea"},
  {"key": "Paraguay", "value": "Paraguay"},
  {"key": "Peru", "value": "Peru"},
  {"key": "Philippines", "value": "Philippines"},
  {"key": "Pitcairn Islands", "value": "Pitcairn Islands"},
  {"key": "Poland", "value": "Poland"},
  {"key": "Portugal", "value": "Portugal"},
  {"key": "Puerto Rico", "value": "Puerto Rico"},
  {"key": "Qatar", "value": "Qatar"},
  {"key": "Republic of the Congo", "value": "Republic of the Congo"},
  {"key": "Reunion", "value": "Reunion"},
  {"key": "Romania", "value": "Romania"},
  {"key": "Russia", "value": "Russia"},
  {"key": "Rwanda", "value": "Rwanda"},
  {"key": "Saint Helena", "value": "Saint Helena"},
  {"key": "Saint Kitts and Nevis", "value": "Saint Kitts and Nevis"},
  {"key": "Saint Lucia", "value": "Saint Lucia"},
  {"key": "Saint Martin", "value": "Saint Martin"},
  {"key": "Saint Pierre and Miquelon", "value": "Saint Pierre and Miquelon"},
  {"key": "Saint Vincent and the Grenadines", "value": "Saint Vincent and the Grenadines"},
  {"key": "Samoa", "value": "Samoa"},
  {"key": "San Marino", "value": "San Marino"},
  {"key": "Sao Tome and Principe", "value": "Sao Tome and Principe"},
  {"key": "Saudi Arabia", "value": "Saudi Arabia"},
  {"key": "Senegal", "value": "Senegal"},
  {"key": "Serbia", "value": "Serbia"},
  {"key": "Seychelles", "value": "Seychelles"},
  {"key": "Sierra Leone", "value": "Sierra Leone"},
  {"key": "Singapore", "value": "Singapore"},
  {"key": "Sint Maarten", "value": "Sint Maarten"},
  {"key": "Slovakia", "value": "Slovakia"},
  {"key": "Slovenia", "value": "Slovenia"},
  {"key": "Solomon Islands", "value": "Solomon Islands"},
  {"key": "Somalia", "value": "Somalia"},
  {"key": "South Africa", "value": "South Africa"},
  {"key": "South Korea", "value": "South Korea"},
  {"key": "South Sudan", "value": "South Sudan"},
  {"key": "Spain", "value": "Spain"},
  {"key": "Sri Lanka", "value": "Sri Lanka"},
  {"key": "Sudan", "value": "Sudan"},
  {"key": "Suriname", "value": "Suriname"},
  {"key": "Sweden", "value": "Sweden"},
  {"key": "Switzerland", "value": "Switzerland"},
  {"key": "Syria", "value": "Syria"},
  {"key": "Taiwan", "value": "Taiwan"},
  {"key": "Tajikistan", "value": "Tajikistan"},
  {"key": "Tanzania", "value": "Tanzania"},
  {"key": "Thailand", "value": "Thailand"},
  {"key": "Timor-Leste", "value": "Timor-Leste"},
  {"key": "Togo", "value": "Togo"},
  {"key": "Tokelau", "value": "Tokelau"},
  {"key": "Tonga", "value": "Tonga"},
  {"key": "Trinidad and Tobago", "value": "Trinidad and Tobago"},
  {"key": "Tunisia", "value": "Tunisia"},
  {"key": "Turkey", "value": "Turkey"},
  {"key": "Turkmenistan", "value": "Turkmenistan"},
  {"key": "Tuvalu", "value": "Tuvalu"},
  {"key": "Uganda", "value": "Uganda"},
  {"key": "Ukraine", "value": "Ukraine"},
  {"key": "United Arab Emirates", "value": "United Arab Emirates"},
  {"key": "United Kingdom", "value": "United Kingdom"},
  {"key": "United States", "value": "United States"},
  {"key": "Uruguay", "value": "Uruguay"},
  {"key": "Uzbekistan", "value": "Uzbekistan"},
  {"key": "Vanuatu", "value": "Vanuatu"},
  {"key": "Vatican City", "value": "Vatican City"},
  {"key": "Venezuela", "value": "Venezuela"},
  {"key": "Vietnam", "value": "Vietnam"},
  {"key": "Western Sahara", "value": "Western Sahara"},
  {"key": "Yemen", "value": "Yemen"},
  {"key": "Zambia", "value": "Zambia"},
  {"key": "Zimbabwe", "value": "Zimbabwe"}
]
